import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import Multitessere from "../../pages/Multitessere";
import AllertIscrizione6 from "../multitessere/AllertIscrizione6";

function IndividualiAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                                    <th scope="col" style={{width: "40%"}}>
                                        5 lezioni
                                    </th>
                                    <th scope="col" style={{width: "40%"}}>
                                        10 lezioni
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Singole</th>
                                    <td className={"data-cell"}>180€</td>
                                    <td className={"data-cell"}>340€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Coppia</th>
                                    <td className={"data-cell"}>135€ a persona</td>
                                    <td className={"data-cell"}>225€ a persona</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione6 />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IndividualiAccordionPrezzi